export const AppUI = {
  labels: {
    Note: 'Lưu ý',
    NutritionCalculator: 'Công cụ tính calci và dinh dưỡng từ thực phẩm',
    CalculatorTool: 'Công cụ tính toán',
    HomePage: 'Trang chủ'
  },
  messages: {
    Guide: 'Vui lòng chọn món ăn và khối lượng thức ăn trong 1 ngày của bạn',
    Note1: '* Nhu cầu khuyến nghị năng lượng và chất dinh dưỡng trung bình cần thiết cho nam giới trưởng thành khoẻ mạnh từ 20-29 tuổi, có cân nặng trung bình 61.6 kg, hoạt động thể lực mức trung bình (các ngành nghề như công nhân công nghiệp nhẹ, sinh viên, công nhân xây dựng, lao động nông nghiệp, chiến sĩ quân đội không trong chiến đậu tập luyện, đánh bắt cá/thuỷ sản).',
    Note2: 'Nhu cầu dinh dưỡng - khuyến nghị cho người Việt Nam 2016. Các tính toán trên đây được được tính trung bình dựa trên các món ăn, thực phẩm thông dụng có tại khu vực phía nam. Trường hợp cá nhân cần một chế độ ăn riêng cho từng bệnh lý, hoặc biết được kết quả tính toán có đạt nhu cầu hay cần đều chỉnh theo mong muốn cần tham khảo ý kiến chuyên gia.'
  }
}

export const MealListUI = {
  buttons: {
    Calculate: 'Tính'
  },
  labels: {
    Nutritions: 'Thành phần dinh dưỡng chính',
    NutritionsInMeal: 'Dinh dưỡng trong bữa ăn của bạn',
    RecommendedNutritionsInMeal: 'Nhu cầu khuyến nghị trung bình trong ngày (*)',
    Energy: 'Năng Lượng (kcalo)',
    Protid: 'Đạm/Protid (gam)',
    Lipid: 'Chất béo/Lipid (gam)',
    Glucid: 'Chất bột đường/Glucid (gam)',
    Fiber: 'Chất xơ/Fiber (gam)',
    Canxi: 'Canxi (miligram)',
    Result: 'Kết quả'
  }
}

export const SubCategoryListUI = {
  buttons: {
    Choose: 'Chọn'
  }
}



// WEBPACK FOOTER //
// ./src/lang/vn.js